import { useEffect, useState } from "react";
import AdminLayout from "@/pages/admin/AdminLayout";
import api from "@/lib/api";
import { formatDateTime } from "@/lib/date";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";

export default function LeadsPage() {
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    api.get("/admin/leads").then(({ data }) => setLeads(data));
  }, []);

  return (
    <AdminLayout>
      <h1 className="text-2xl font-semibold text-slate-900" data-testid="leads-page-heading">
        Demo Requests / Leads
      </h1>
      <div className="mt-6">
        <Table>
          <TableHeader>
            <TableRow className="sticky top-0">
              <TableHead>Name</TableHead>
              <TableHead>Clinic</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Mobile</TableHead>
              <TableHead>Submitted</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {leads.map((l, i) => (
              <TableRow key={l.id} data-testid={`lead-row-${l.id}`}>
                <TableCell>{l.first_name} {l.last_name}</TableCell>
                <TableCell>{l.clinic_name}</TableCell>
                <TableCell>{l.email}</TableCell>
                <TableCell>{l.mobile}</TableCell>
                <TableCell className="text-slate-600">{formatDateTime(l.created_at)}</TableCell>
              </TableRow>
            ))}
            {leads.length === 0 && (
              <TableRow><TableCell colSpan={5} className="py-8 text-center text-slate-400">No leads yet.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </AdminLayout>
  );
}
